import noop from 'lodash/noop';

import { Alert, AlertTitle } from 'shared/components/Alert';

import type { AlertProps } from '@mui/material';
import type { FC } from 'react';

export interface ToastProps extends Pick<AlertProps, 'severity'> {
  header?: string;
  description?: string;
  onClose?(): void;
}

export const Toast: FC<ToastProps> = ({
  header,
  description,
  onClose = noop,
  severity,
}) => (
  <Alert
    sx={{ width: 456, borderRadius: '16px' }}
    severity={severity}
    color={severity}
    variant="filled"
    onClose={onClose}
  >
    {header && <AlertTitle color="white">{header}</AlertTitle>}
    {description}
  </Alert>
);
